import React, { useState, createContext, useMemo } from 'react';
import styled from 'styled-components';

interface IWrapper {
  $overflowNotHidden?: boolean;
}

export const FixedContext = createContext(null);

const Wrapper = styled.div<IWrapper>`
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  overflow: ${(props: IWrapper) =>
    props.$overflowNotHidden ? 'visible' : 'hidden'};
  flex-direction: column;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    overflow: hidden;
  }
`;

const WrappedContext: React.FC<IWrapper> = ({
  $overflowNotHidden,
  children,
}) => {
  const [isFixed, setIsFixed] = useState(false);

  const fixedMemo = useMemo(
    () => ({ isFixed, setIsFixed }),
    [isFixed, setIsFixed],
  );

  return (
    <FixedContext.Provider value={fixedMemo}>
      <Wrapper $overflowNotHidden={$overflowNotHidden}>
        <>
          {/* <ProgressBar /> */}
          {children}
        </>
      </Wrapper>
    </FixedContext.Provider>
  );
};

export default WrappedContext;
